import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchResets, fetchStats, PasswordReset, ResetStats } from './model';
export default function useResetData() {
  const [items, setItems] = useState<PasswordReset[]>([]), [stats, setStats] = useState<ResetStats | null>(null);
  const [loading, setLoading] = useState(true), [error, setError] = useState('');
  const [total, setTotal] = useState(0), [partial, setPartial] = useState(false), [statsDays, setStatsDays] = useState(30);
  const alive = useRef(true), generation = useRef(0), requestedDays = useRef(30);
  const reload = useCallback(async (days = requestedDays.current) => {
    if (!Number.isInteger(days) || days < 1 || days > 365) return;
    requestedDays.current = days; const id = ++generation.current; setLoading(true); setError('');
    const [list, summary] = await Promise.allSettled([fetchResets(), fetchStats(days)]);
    if (!alive.current || id !== generation.current) return;
    if (list.status === 'fulfilled') { setItems(list.value.items); setTotal(list.value.total); setPartial(list.value.partial); }
    if (summary.status === 'fulfilled') { setStats(summary.value); setStatsDays(days); }
    setError([list.status === 'rejected' ? 'İstek listesi yüklenemedi. Varsa önceki kayıtlar korunuyor.' : '', summary.status === 'rejected' ? 'İstatistikler yenilenemedi. Önceki dönem bilgileri korunuyor.' : ''].filter(Boolean).join(' ')); setLoading(false);
  }, []);
  useEffect(() => { alive.current = true; reload(); return () => { alive.current = false; generation.current += 1; }; }, [reload]);
  return { items, stats, statsDays, loading, error, total, partial, reload };
}
